import api from "../api/api";

// GET /categories — the one real, existing endpoint (confirmed: no auth,
// no pagination/search support server-side — always returns the full list).
export async function getCategories() {
  const res = await api.get("/categories");
  return res.data;
}
